export default "__VITE_ASSET__DjkVVIoo__"